import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getStaffDashboardCount: (state) => state.staffCount,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
